import {Message} from "primereact/message";
import {useTranslation} from "react-i18next";

import {type CommissionEntitlementsEvaluation, describeMissingEntitlements} from "../../util/valueOrderEntitlements";

/**
 * Hinweis anstelle des Beauftragen-Buttons, wenn der ValueAG-Auftraggeber die Beauftragung nicht zulässt:
 * nennt, was fehlt, damit der Benutzer es nicht erst beim Absenden erfährt.
 */
export function CommissionEntitlementsNotice({evaluation}: {evaluation: CommissionEntitlementsEvaluation}) {
    const {t} = useTranslation();
    if (evaluation.mode !== "blocked") return null;

    const lines = describeMissingEntitlements(t, evaluation);
    const content = (
        <div className="flex items-start gap-2">
            <span className="pi pi-exclamation-triangle mt-1" aria-hidden="true" />
            <div id="commissionEntitlementsNotice" className="leading-normal">
                {evaluation.noClientId && <div>{t("order.revaOrder.entitlements.noClientId")}</div>}
                {evaluation.clientNotPermitted && <div>{t("order.revaOrder.entitlements.clientNotPermitted")}</div>}
                {lines.length > 0 && (
                    <>
                        <div>{t("order.revaOrder.entitlements.blockedIntro")}</div>
                        <ul className="my-1 pl-5 list-disc">
                            {lines.map((line) => (
                                <li key={line}>{line}</li>
                            ))}
                        </ul>
                    </>
                )}
                <div>{t("order.revaOrder.entitlements.contactHint")}</div>
            </div>
        </div>
    );
    return <Message severity="warn" content={content} className="w-full mb-4 justify-start" />;
}
